export default class Gauge {
  constructor(transfer) {
    this.transfer = transfer;
    this.history = [];
    this.state = {
      started: false,
      update: false,
      total: false,
      sent: false,
    };
  }

  // This marks 'now' basically
  static start() {
    return +new Date();
  }

  // Compare now with a given point and get a result in seconds
  static since(start) {
    return (Gauge.start() - start) / 1000;
  }

  // Return the total duration
  get duration() {
    if (!this.state.started) {
      return 0;
    }
    return (new Date() - this.state.started) / 1000;
  }

  // Return the total size it will be measuring
  get total() {
    return this.state.total;
  }

  // Start measuring the transfer from here
  measure() {
    this.state.started = new Date();
  }

  // When paused the time difference will keep growing, to prevent
  // that we reset the last updated time to now.
  resume() {
    this.state.update = Gauge.start();
  }

  // Reset the recorded gauge data
  reset() {
    this.history = [];
    this.state = {
      started: false,
      update: false,
      total: false,
      sent: false,
    };
  }

  // Calculate the estimated remaining time (in seconds) to upload
  // the given total size, based on the amount that is already sent.
  remaining(sent) {
    // First run we don't know the total transfer size yet
    // so we will ask it, nicely with force.
    if (!this.state.total) {
      this.state.total = this.transfer.totalSize;
    }

    // Never updated before, so store what's possible and
    // we'll check again later.
    if (!this.state.update) {
      this.state.update = Gauge.start();
      this.state.sent = sent;
      return false;
    }

    // Only update history every now and then for better samples.
    const timePassed = Gauge.since(this.state.update);
    if (timePassed >= 10) {
      // How many bytes have been sent and how long did it take
      const delta = sent - this.state.sent;
      const bps = delta / timePassed;

      // Update history
      this.history.unshift(bps);
      if (this.history.length >= 16) {
        this.history.pop();
      }

      // Remember this update
      this.state.update = Gauge.start();
      this.state.sent = sent;
    }

    // Calculate avg. bytes per second and est. calculate time remaining
    const bps =
      this.history.reduce((total, speed) => total + speed, 0) /
      this.history.length;
    const secondsLeft = Math.round((this.state.total - sent) / bps);
    return isFinite(secondsLeft) ? secondsLeft : false;
  }
}
